<template>
    <v-form ref="formUrgencia">
        <v-row>
            <v-col cols="6">
                <v-text-field label="Paciente" :value="localUrgencia.Paciente" disabled outlined
                    dense></v-text-field>
            </v-col>
            <!-- <v-col cols="6">
                <v-radio-group :rules="[v => !!v || 'Selecciona una opción']" v-model="localUrgencia.Tipo" row>
                    <v-radio label="¿Fue un accidente?" value="2" />
                    <v-radio label="¿Fue una enfermedad?" value="1" />
                </v-radio-group>
            </v-col> -->
            <v-col cols="4">
                <v-text-field v-model="localUrgencia.FechaIngreso" label="Fecha de ingreso"
                   prepend-icon="mdi-calendar" readonly v-mask="'####-##-##'" outlined dense 
                    :rules="[rules.ruleFecha]" placeholder="AAAA-MM-DD" />
            </v-col>
            <!-- <v-col cols="2">
                <v-menu v-model="menuStart1" :close-on-content-click="false" transition="scale-transition" offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="localUrgencia.FechaFactura" label="Fecha de factura"
                            prepend-icon="mdi-calendar" :readonly="true" v-mask="'####-##-##'" outlined dense clearable
                            v-bind="attrs" v-on="on" :rules="[rules.ruleFecha]" placeholder="AAAA-MM-DD" />
                    </template>

                    <v-date-picker v-model="localUrgencia.FechaFactura" no-title scrollable locale="es"
                        @input="menuStart1 = false" />
                </v-menu>
            </v-col>
            <v-col cols="2">
                <v-text-field label="Factura hospital" v-model="localUrgencia.Factura" outlined dense clearable
                    :rules="[rules.ruleRequired]"></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field label="Diagnostico" v-model="localUrgencia.Diagnostico" outlined dense clearable
                    :rules="[rules.ruleRequired]"></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-textarea v-model="localUrgencia.Descripcion" label="Descripción" rows="6" auto-grow outlined dense>
                </v-textarea>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
                <v-text-field v-model="localUrgencia.Total" label="Total" prefix="$" outlined dense clearable
                    :rules="[rules.ruleRequired, reglaMonto]" style="max-width: 200px;" />
            </v-col> -->
        </v-row>
    </v-form>
</template>


<script>
export default {
    name: 'UrgenciaForm',
    props: {
        urgencia: {
            type: Object,
            required: true
        }
    },
    computed: {
        rules() {
            return this.$rules;
        },
        reglaMonto() {
            return v => {
                if (v === null || v === '' || isNaN(v)) return 'Ingresa un monto válido';
                if (v <= 0) return 'El monto debe ser mayor a 0';

                const max = this.localUrgencia.MontoMaxUrgencias;
                const formatoPesos = new Intl.NumberFormat('es-MX', {
                    style: 'currency',
                    currency: 'MXN',
                    minimumFractionDigits: 2
                }).format(max);

                if (v > max) return `El monto no puede superar ${formatoPesos}`;
                return true;
            };

        }
    },
    data() {
        return {
            menuStart: false,
            menuStart1: false,
            localUrgencia: { ...this.urgencia } // Hacemos una copia para no mutar la prop
        };
    },
    watch: {
        urgencia: {
            handler(nueva) {
                this.localUrgencia = { ...nueva }; // Si la prop cambia desde el padre, la actualizamos
            },
            deep: true
        }
    },
    methods: {
        getUrgencia() {
            return this.localUrgencia;
        }
    }
};

</script>